import { defineTextStyles } from '@chakra-ui/react'

const soehne = "'Soehne', sans-serif"
const soehneKraftig = "'Soehne Kraftig', sans-serif"
const soehneBreit = "'Soehne Breit', sans-serif"
const soehneMono = "'Soehne Mono', sans-serif"

export const textStyles = defineTextStyles({
  // ─── Display ──────────────────────────────────────────────────────────────
  'display-extended': {
    description: 'Söhne Breit Kräftig · 32/40 · -1% — brand & impact moments',
    value: {
      fontFamily: soehneBreit,
      fontSize: '32px',
      lineHeight: '40px',
      letterSpacing: '-0.32px',
      fontWeight: '500',
    },
  },
  display: {
    description: 'Söhne Kräftig · 32/40 · -1%',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '32px',
      lineHeight: '40px',
      letterSpacing: '-0.32px',
      fontWeight: '500',
    },
  },

  // ─── Headings ─────────────────────────────────────────────────────────────
  title: {
    description: 'Söhne Kräftig · 24/32 · -0.5%',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '24px',
      lineHeight: '32px',
      letterSpacing: '-0.12px',
      fontWeight: '500',
    },
  },
  'heading-l': {
    description: 'Söhne Kräftig · 28/36 · -0.5%',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '28px',
      lineHeight: '36px',
      letterSpacing: '-0.14px',
      fontWeight: '500',
    },
  },
  heading: {
    description: 'Söhne Kräftig · 20/28',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: '500',
    },
  },

  // ─── Body ─────────────────────────────────────────────────────────────────
  'body-large': {
    description: 'Söhne Buch · 18/28',
    value: {
      fontFamily: soehne,
      fontSize: '18px',
      lineHeight: '28px',
      fontWeight: '400',
    },
  },
  'body-large-bold': {
    description: 'Söhne Kräftig · 18/28 — use sparingly, emphasis only',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '18px',
      lineHeight: '28px',
      fontWeight: '500',
    },
  },
  body: {
    description: 'Söhne Buch · 16/24',
    value: {
      fontFamily: soehne,
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '400',
    },
  },
  'body-bold': {
    description: 'Söhne Kräftig · 16/24',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '500',
    },
  },

  // ─── Label / Caption ──────────────────────────────────────────────────────
  label: {
    description: 'Söhne Kräftig · 14/20',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '500',
    },
  },
  caption: {
    description: 'Söhne Buch · 12/16',
    value: {
      fontFamily: soehne,
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: '400',
    },
  },
  'caption-medium': {
    description: 'Söhne Kräftig · 12/16',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: '500',
    },
  },
  overline: {
    description: 'Söhne Kräftig · 12/16 · 8% · UPPERCASE',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.96px',
      fontWeight: '500',
      textTransform: 'uppercase',
    },
  },
  accent: {
    description: 'Söhne Mono Buch · 12/20 · 1px — IDs, code, timestamps',
    value: {
      fontFamily: soehneMono,
      fontSize: '12px',
      lineHeight: '20px',
      letterSpacing: '1px',
      fontWeight: '400',
    },
  },

  // ─── Small ────────────────────────────────────────────────────────────────
  'small-body': {
    description: 'Söhne Buch · 11/16',
    value: {
      fontFamily: soehne,
      fontSize: '11px',
      lineHeight: '16px',
      fontWeight: '400',
    },
  },
  'small-body-bold': {
    description: 'Söhne Kräftig · 11/16',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '11px',
      lineHeight: '16px',
      fontWeight: '500',
    },
  },
  'small-label': {
    description: 'Söhne Kräftig · 10/16',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '10px',
      lineHeight: '16px',
      fontWeight: '500',
    },
  },
  'small-caption': {
    description: 'Söhne Buch · 8/12 · 0.5px',
    value: {
      fontFamily: soehne,
      fontSize: '8px',
      lineHeight: '12px',
      letterSpacing: '0.5px',
      fontWeight: '400',
    },
  },
  'small-caption-medium': {
    description: 'Söhne Kräftig · 8/12 · 0.5px',
    value: {
      fontFamily: soehneKraftig,
      fontSize: '8px',
      lineHeight: '12px',
      letterSpacing: '0.5px',
      fontWeight: '500',
    },
  },
  'small-accent': {
    description: 'Söhne Mono Buch · 8/12 · 1px',
    value: {
      fontFamily: soehneMono,
      fontSize: '8px',
      lineHeight: '12px',
      letterSpacing: '1px',
      fontWeight: '400',
    },
  },
})
